import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap, switchMap, tap } from 'rxjs/operators';
import { FeatureFlagService } from 'libs/desktop/data-access/core-services/src/lib/FeatureFlag/feature-flag.service';
import { AccountCreationSteps } from '@brightside-web/desktop/feature/financial-accounts-core';
import { LoanPayload, NewLoansService } from './new-loans.service';

const allowedVendors = ['Kashable'];

@Injectable({
  providedIn: 'root',
})
export class CanGoToDashboardGuard implements CanActivate {
  constructor(private router: Router, private _featureFlagSvc: FeatureFlagService, private _loansService: NewLoansService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const vendor = route.queryParamMap.get('vendor') || '';
    return this._featureFlagSvc.getFlag<boolean>('enable-loan-visibility-in-apps').pipe(
      switchMap((shouldGoToDashboard) =>
        this._loansService.getLoanByPartnerType(vendor).pipe(
          mergeMap((res) => {
            const loans = (res as LoanPayload).payload?.loans;
            const isVendorAllowed = allowedVendors.includes(vendor);
            const foundLoan = loans.filter((loan) => loan.isTaken)[0];

            if (shouldGoToDashboard && loans.length && foundLoan) {
              if (isVendorAllowed) {
                return of(true);
              } else {
                this.router.navigate(['accounts', 'loans', 'info']);
                return of(false);
              }
            }
            this.router.navigate(['accounts', 'loans', 'creation', AccountCreationSteps.INTRO]);
            return of(false);
          })
        )
      )
    );
  }
}
